var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SidebarLayout',{scopedSlots:_vm._u([{key:"nav",fn:function(){return [_c('SettingsNav')]},proxy:true},{key:"body",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }